export default "__VITE_ASSET__BO07rCmf__"